/** Client-side price preview for the booking wizard. Server is authoritative. */
export function computePrice({ basePrice, minHours, additionalHourPrice, durationHours }) {
  const extra = Math.max(0, durationHours - minHours);
  const per =
    additionalHourPrice != null ? Number(additionalHourPrice) : basePrice / minHours;
  const subtotal = Number(basePrice) + extra * per;
  return {
    subtotal,
    base: Number(basePrice),
    extraHours: extra,
    perHour: per,
    additional: extra * per,
  };
}

export function formatMoney(n, currency = "USD") {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(n);
}

/** Format cents as a rounded currency string ($500, $3,000). */
export function formatCents(cents, currency = "USD") {
  const n = Number(cents ?? 0) / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(n);
}
